import React, { useState, useEffect, FC, useCallback, useMemo } from "react";
import Content from "../../layout/content/Content";
import { Card, Row, Col } from "reactstrap";
import {
  TableColumnsType,
  Table,
  Progress,
  Select,
  Input,
  Flex,
  Spin,
  Empty,
  Button,
} from "antd";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import FormatDate from "../masters/DateFormater";
import { SearchOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import InventoryAside from "./InventoryAside";
import invoiceApis from "../../api/Invoice/invoice";
import ServerSideTable from "../form-components/PaginationTableComponent";
import purchaseOrderApis from "../../api/master/PurchaseOrder";
import inventoryCreation from "../../api/inventory/inventoryCreation";
import { EditOutlined, SaveOutlined, CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import dayjs from "dayjs";
import SiteInventoryAllocationDrawer from "./SiteInventoryAllocationDrawer";
import { render } from "@testing-library/react";
import { set } from "date-fns";
import supplierApis from "../../api/master/supplier";
import boqApis from "../../api/boq/boq";
import contractorsApis from "../../api/master/contractors";
import rolesApi from "../../api/master/roles";
const { Option } = Select;
interface WidgetData {
  title: string;
  count: number;
  progress: number;
  color: string;
}

const SiteIssue: FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [sm, setSm] = useState(false);
  const navigate = useNavigate();
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [externalData, setExternalData] = useState(null);
  const [rowData, setRowData] = useState<any>([]);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false); // Track unsaved changes
  const [showSubmitDrawer, setShowSubmitDrawer] = useState(false);
  const [site, setSite] = useState("");
  const [category, setCategory] = useState("");
  const [contractor, setContractor] = useState("");
  const [contractorOptionsState, setContractorOptionsState] = useState<any>([]);
  const [siteOptions, setSiteOptions] = useState<any>([]);
  const { data: currentUser } = useSelector(
    (state: RootState) => state.currentUser
  );
  const [pagination, setPagination] = useState<any>({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [data, setData] = useState<any[]>([]);
  const [editingKey, setEditingKey] = useState<string | null>(null);
  const [editValues, setEditValues] = useState<{ [key: string]: any }>({});
  const [sortOrder, setSortOrder] = useState("DESC");
  const [direction, setDirection] = useState("P");
  const [orderNumber, setOrderNumber] = useState(null);
  const [previousPage, setPreviousPage] = useState(0);
  const [categoryOptions, setCategoryOptions] = useState<any>([]);
  const [persistedEdits, setPersistedEdits] = useState<{ [key: string]: any }>({});
  const [boqData, setBoqData] = useState<any[]>([]);
  const [isFinalApprover, setIsFinalApprover] = useState<boolean>(false);

  const isAdmin =
    (currentUser as any)?.genericRole?.toLowerCase() === "admin";
  const canBypassApproval = isFinalApprover === true || isAdmin;

  useEffect(() => {
    if (!site) {
      setIsFinalApprover(false);
      return;
    }
    (async () => {
      try {
        const moduleRes = await rolesApi.findAllModuleConfig();
        const moduleID = moduleRes?.data?.find(
          (x: any) => x.moduleName == "Material Issue"
        )?.moduleID;
        let isFinal = false;
        if (moduleID) {
          const res = await rolesApi.fetchHierarchyUsersByModuleId(
            moduleID,
            site
          );
          const msg = (res?.message || "").toString().toLowerCase();
          isFinal = msg.includes("you are the final");
        }
        setIsFinalApprover(isFinal);
      } catch (err) {
        console.log("Error checking final approver:", err);
        setIsFinalApprover(false);
      }
    })();
  }, [site]);

  useEffect(() => {
    if (site && contractor) {
      (async () => {
        try {
          const response = await boqApis.fetchContractorBoqDropdown({
            siteIds: site.toString(),
            contractorIds: contractor.toString(),
          });
          const data = response?.data || response?.response || [];
          setBoqData(Array.isArray(data) ? data : []);
        } catch (error) {
          console.log("Failed to fetch BOQ data:", error);
          setBoqData([]);
        }
      })();
    } else {
      setBoqData([]);
    }
  }, [site, contractor]);

  const fetchContractorList = async (siteId: any) => {
    if (!siteId) {
      setContractorOptionsState([]);
      return;
    }
    try {
      const { data, status } = await contractorsApis.fetchContractorBySiteId({
        id: siteId + "",
      });
      if (status) {
        const options = (data || []).map((item: any) => ({
          label: item?.companyName,
          value: item?.contractorID?.toString(),
        }));
        setContractorOptionsState(options);
      }
    } catch (error) {
      console.log(error);
      setContractorOptionsState([]);
    }
  };

  useEffect(() => {
    setContractor("");
    setPersistedEdits({});
    setHasUnsavedChanges(false);
    if (site) {
      fetchContractorList(site);
    } else {
      setContractorOptionsState([]);
    }
  }, [site]);

  const handleContractorChange = (value: string) => {
    setContractor(value || "");
    setPersistedEdits({});
    setHasUnsavedChanges(false);
    setEditingKey(null);
    setEditValues({});
  };

  const exceededMaterials = useMemo(() => {
    if (!boqData.length) return [];
    const editedLines = Object.values(persistedEdits).filter(
      (item: any) => item.uomQty && item.uomQty !== ""
    );
    if (!editedLines.length) return [];
    const exceeded: {
      label: string;
      enteredQty: number;
      remainingQty: number;
    }[] = [];
    editedLines.forEach((item: any) => {
      const matched = boqData.find(
        (boq: any) =>
          (boq.materialId?.toString() || boq.materialID?.toString()) ===
          item.materialId?.toString()
      );
      if (matched) {
        const enteredQty = parseFloat(item.uomQty) || 0;
        const issueRemainingQty = parseFloat(matched.issueRemainingQty) || 0;
        if (enteredQty > issueRemainingQty) {
          exceeded.push({
            label: item.materialName || item.categoryName,
            enteredQty,
            remainingQty: issueRemainingQty,
          });
        }
      }
    });
    return exceeded;
  }, [boqData, persistedEdits]);

  const shouldBlockNext =
    exceededMaterials.length > 0 && !canBypassApproval;

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };
  useEffect(() => {
    viewChange();
    // fetchAllInvoices();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  const columns = [
    {
      title: "#",
      key: "#",
      width: 50,
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
    {
      title: "Material Category",
      dataIndex: "categoryName",
      key: "categoryName",
      width: 200,
    },
    {
      title: "Material Name",
      dataIndex: "materialName",
      key: "materialName",
      width: 200,
    },
    {
      title: "UOM",
      dataIndex: "primaryUomName",
      key: "primaryUomName",
      width: 200,
    },
    {
      title: "Qty Available For Utilization",
      dataIndex: "quantityAvailable",
      key: "quantityAvailable",
      width: 220,
      render: (text: number, record: any) => (
        <div>
          <span>{text?.toLocaleString("en-IN")}</span>
        </div>
      ),
    },
    {
      title: "Qty To Issue",
      dataIndex: "uomQty",
      key: "uomQty",
      editable: true,
      width: 170,
      render: (text: number, record: any) =>
        editingKey === record.paginationId ? (
          <Input
            type="number"
            // min={1} // Prevent direct typing of numbers less than 1
            min={0}
            step={0.001}
            value={editValues[record.paginationId]?.uomQty ?? text}
            onChange={(e) =>
              handleFieldChange(
                record.paginationId,
                "uomQty",
                e.target.value // Allow user to type freely
              )
            }
            onBlur={(e) =>
              handleFieldChange(
                record.paginationId,
                "uomQty",
                validateQuantity(e.target.value, record.quantityAvailable) // Validate on blur
              )
            }
          />
        ) : (
          record.uomQty
        ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (text: any, record: any) =>
        editingKey === record.paginationId ? (
          <div>
            <Button
              type="link"
              icon={<SaveOutlined />}
              onClick={() => commitChanges(record.paginationId)}
            />
            <Button
              type="link"
              icon={<CloseOutlined />}
              onClick={() => cancelEdit()}
            />
          </div>
        ) : (
          <div style={{ display: "flex", gap: "8px" }}>
            {contractor ? (
              <EditOutlined onClick={() => handleEdit(record.paginationId)} />
            ) : (
              <EditOutlined
                style={{ color: "#bfbfbf", cursor: "not-allowed" }}
                title="Please select a Contractor to edit"
              />
            )}

            {persistedEdits[record.paginationId] && (
              <DeleteOutlined
                style={{ color: "red", cursor: "pointer" }}
                onClick={() => deleteLine(record.paginationId)}
              />
            )}
          </div>
        ),
    },
  ];

  // const validateQuantity = (value: string, maxAvailable: number): number => {
  //   const numericValue = Number(value);

  //   if (numericValue < 1) return 1; // Minimum value is 1
  //   if (numericValue > maxAvailable) return maxAvailable; // Clamp to max available

  //   return numericValue; // Return valid value
  // };

  const validateQuantity = (value: string, maxAvailable: number): number => {
    const numericValue = Number(value);
    if (isNaN(numericValue) || numericValue <= 0) return 0;
    if (numericValue > maxAvailable) return maxAvailable;
    return numericValue;
  };

  const handleSiteChange = (value: string) => {
    setSite(value);
    setPagination({ ...pagination, current: 1 }); // Reset pagination on site change
  };

  const handleCategoryChange = (value: string) => {
    setCategory(value);
    setPagination({ ...pagination, current: 1 }); // Reset pagination on category change
  };

  const handleEdit = (id: string) => {
    const currentItem = data.find((item: any) => item.paginationId === id);
    if (currentItem) {
      setEditValues((prev) => ({
        ...prev,
        [id]: { ...currentItem },
      }));
      setEditingKey(id);
    }
  };

  const handleFieldChange = (key: string, field: string, value: any) => {
    setEditValues((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
  };

  const commitChanges = (id: string) => {
    const updatedItem = data.find((item: any) => item.paginationId === id);

    if (!updatedItem) return;

    const finalQty = editValues[id]?.uomQty || updatedItem.uomQty;

    const fullRow = {
      ...updatedItem,
      uomQty: finalQty,
    };

    // Update current page UI
    const updatedData = data.map((item: any) =>
      item.paginationId === id ? fullRow : item
    );

    setData(updatedData);

    // ✅ Store FULL ROW
    setPersistedEdits((prev) => ({
      ...prev,
      [id]: fullRow,
    }));

    setEditingKey(null);
    setEditValues({});
    setHasUnsavedChanges(true);
  };

  const cancelEdit = () => {
    setEditingKey(null);
    setEditValues({});
  };

  const deleteLine = (id: string) => {
    setPersistedEdits((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });

    setData((prev) =>
      prev.map((item: any) =>
        item.paginationId === id ? { ...item, uomQty: "" } : item
      )
    );

    setHasUnsavedChanges(
      Object.keys(persistedEdits).length - 1 > 0
    );
  };

  const fetchData = async (params: any) => {
    console.log("Params", params);
    setIsLoading(true);
    try {
      const response = await inventoryCreation.fetchSiteInventory(
        params.sortOrder,
        params.pageSize,
        params.direction,
        params.pageDiff,
        params.orderNumber,
        params.siteId,
        params.categoryId || null
      );
      const apiData = response.response;

      const enrichedData = apiData?.data?.list.map((item: any) => {
        if (persistedEdits[item.paginationId]) {
          return persistedEdits[item.paginationId];
        }

        return {
          ...item,
          uomQty: item.uomQty || "",
        };
      });

      setData(enrichedData);
      setPagination((prev: any) => ({
        ...prev,
        total: direction === "P" ? apiData.data.count : prev.total,
      }));
    } catch (error) {
      console.error("API Error:", error);
      setData([]);
      setPagination((prev: any) => ({
        ...prev,
        total: 0,
      }));
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = () => {
    console.log("Submitting data:", rowData);

    const selectedLines = Object.values(persistedEdits).filter(
      (item: any) => item.uomQty && item.uomQty !== ""
    );

    if (selectedLines.length === 0) {
      Swal.fire("Warning", "Please add at least one line", "warning");
      return;
    }

    const uniqueSites = Array.from(
      new Set(selectedLines.map((item: any) => item.siteId))
    );

    if (uniqueSites.length > 1) {
      Swal.fire(
        "Warning",
        "You cannot select materials from different sites for a single Material Issue",
        "warning"
      );
      return;
    }

    if (shouldBlockNext) {
      const materialsHtml = exceededMaterials
        .map(
          (item) =>
            `<b>${item.label}</b>: Entered Qty (${item.enteredQty}) exceeds Issue Remaining Qty (${item.remainingQty})`
        )
        .join("<br/>");
      Swal.fire({
        icon: "warning",
        title: "Issue Quantity Exceeded",
        html: `${materialsHtml}<br/><br/> Approval is required to proceed.`,
      });
      return;
    }

    setShowSubmitDrawer(true);
    // Add API call or submission logic here
    // setHasUnsavedChanges(false); // Reset the Submit button
  };

  const handelCreationSubmit = async (formValues: any) => {
    console.log("data", formValues);

    // Per-line task allocations captured in the drawer, keyed by paginationId.
    const lineTasks: Record<string, any[]> = formValues?.lineTasks || {};

    // Header matches the backend stub: contractorId, siteId, approvalRequired.
    const headerPayload: any = {
      issueNumber: formValues.FormData.issueId || null,
      numberingMode: formValues.FormData.numberingMode,
      contractorId: formValues.FormData.contractorId
        ? Number(formValues.FormData.contractorId)
        : null,
      siteId: formValues.FormData.siteId
        ? Number(formValues.FormData.siteId)
        : null,
      approvalRequired: formValues.FormData.approvals === "true" ? "Y" : "N",
    };

    let formData = {
      header: headerPayload,
      lines: allEditedLines.map((item: any) => {
        const tasksForLine = (lineTasks[item.paginationId] || [])
          .filter((t: any) => t.taskId)
          .map((t: any) => ({
            taskId: Number(t.taskId),
            taskBoqId: t.taskBoqId != null ? Number(t.taskBoqId) : null,
            uomQty: t.uomQty != null && t.uomQty !== "" ? Number(t.uomQty) : null,
          }));
        const lineEntry: any = {
          inventoryId: item.inventoryId,
          materialId: item.materialId,
          categoryId: item.categoryId,
          uomId: item.primaryUomId,
          uomType: "primary",
          uomQty: Number(item.uomQty),
        };
        if (tasksForLine.length > 0) {
          lineEntry.tasks = tasksForLine;
        }
        return lineEntry;
      }),
      approvals: formValues.approvalsData,
    };
    console.log("formData", formData);
    try {
      const { response, message, status } =
        await inventoryCreation.createSiteIssue(formData);
      console.log("response", response);
      if (status == true) {
        Swal.fire("Success", message, "success");
        setShowSubmitDrawer(false);
        setHasUnsavedChanges(false); // Reset the Submit button
        navigate("/material-issue");
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error: any) {
      console.error("Failed to submit data:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to submit data";
      Swal.fire("Error", errorMessage, "error");
    }
  };

  useEffect(() => {
    if (currentUser) {
      const { siteAccessibility } = currentUser;
      if (siteAccessibility) {
        const options = currentUser.siteAccessibility.map((item: any) => ({
          label: item.siteName,
          value: item.siteID,
        }));
        setSiteOptions(options);
      }
    }
    fetchCategoryFilter();
  }, [currentUser]);

  const fetchCategoryFilter = async () => {
    try {
      const { data, status } = await supplierApis.fetchSupplierCategory();
      if (status) {
        let _categoryOptions: any = [];
        let allCategory: any = [];
        data.forEach((item: any) => {
          allCategory.push(item?.id?.toString());
          _categoryOptions.push({
            label: item?.category,
            value: item?.id?.toString(),
          });
        });
        // setValue("category", allCategory?.join(","));
        if (_categoryOptions.length > 1) {
          _categoryOptions = [
            // {
            //   label: "ALL",
            //   value: allCategory?.join(","),
            // },
            ..._categoryOptions,
          ];
        }
        setCategoryOptions(_categoryOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (site) {
      const pageDiff =
        direction === "P"
          ? pagination.current - 1
          : Math.abs(pagination.current - previousPage) - 1;

      const apiParams = {
        sortOrder,
        pageSize: pagination.pageSize.toString(),
        direction,
        pageDiff,
        orderNumber,
        siteId: site,
        categoryId: category,
      };
      fetchData(apiParams);
    }
    console.log("category", category);
    if (category) {
      const pageDiff =
        direction === "P"
          ? pagination.current - 1
          : Math.abs(pagination.current - previousPage) - 1;
      const apiParams = {
        sortOrder,
        pageSize: pagination.pageSize.toString(),
        direction,
        pageDiff,
        orderNumber,
        siteId: site,
        categoryId: category,
      };
      fetchData(apiParams);
    }
  }, [
    site,
    pagination.current,
    pagination.pageSize,
    direction,
    orderNumber,
    previousPage,
    sortOrder,
    category,
  ]);

  const allEditedLines = Object.values(persistedEdits).filter(
    (item: any) => item.uomQty && item.uomQty !== ""
  );

  const selectedSiteId = allEditedLines[0]?.siteId;

  return (
    <>
      <Head title="Issue Material" />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            <div
              className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${sm ? "content-active" : ""
                }`}
            >
              <InventoryAside updateSm={setSm} sm={sm} />
            </div>
            <div className="card-inner card-inner-lg">
              {sm && mobileView && (
                <div
                  className="toggle-overlay"
                  onClick={() => setSm(!sm)}
                ></div>
              )}
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent>
                    <BlockTitle tag="h4">
                      <span>Issue Material</span>
                    </BlockTitle>
                  </BlockHeadContent>
                  <BlockHeadContent className="align-self-start d-lg-none">
                    <Button
                      className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""
                        }`}
                      onClick={() => setSm(!sm)}
                    >
                      <Icon name="menu-alt-r" />
                    </Button>
                  </BlockHeadContent>

                  {hasUnsavedChanges && (
                    <div className="actions clearfix">
                      <ul
                        className="m-auto d-flex align-items-center justify-content-center p-0"
                        style={{
                          flexDirection: "row-reverse",
                        }}
                      >
                        <li className="pt-0 pb-0">
                          <Button
                            type="primary"
                            onClick={handleSubmit}
                            style={{ marginTop: "20px" }}
                          >
                            Submit
                          </Button>
                        </li>
                      </ul>
                    </div>
                  )}
                </BlockBetween>
              </BlockHead>
              <Row>
                <Col md="4">
                  <label style={{ fontWeight: "bold", marginRight: 8 }}>
                    Filter by Site:
                  </label>
                  <Select
                    style={{ width: 200 }}
                    onChange={handleSiteChange}
                    value={site}
                    allowClear
                    showSearch
                    placeholder="Select Site"
                    filterOption={(input, option: any) =>
                      option?.children
                        ?.toLowerCase()
                        ?.includes(input?.toLowerCase())
                    }
                  >
                    {siteOptions?.map((item: any) => (
                      <Option value={item.value} key={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col md="4">
                  <label style={{ fontWeight: "bold", marginRight: 8 }}>
                    Filter by Category:
                  </label>
                  <Select
                    showSearch
                    placeholder="Select Category"
                    style={{ width: 200 }}
                    onChange={handleCategoryChange}
                    value={category}
                    allowClear
                    filterOption={(input, option: any) =>
                      option?.children
                        ?.toLowerCase()
                        ?.includes(input?.toLowerCase())
                    }
                  >
                    {categoryOptions?.map((item: any) => (
                      <Option value={item.value} key={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col md="4">
                  <label style={{ fontWeight: "bold", marginRight: 8 }}>
                    Contractor:
                  </label>
                  <Select
                    showSearch
                    placeholder="Select Contractor"
                    style={{ width: 200 }}
                    onChange={handleContractorChange}
                    value={contractor || undefined}
                    allowClear
                    disabled={!site}
                    filterOption={(input, option: any) =>
                      option?.children
                        ?.toLowerCase()
                        ?.includes(input?.toLowerCase())
                    }
                  >
                    {contractorOptionsState?.map((item: any) => (
                      <Option value={item.value} key={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>
              <div>
                <div
                  style={{
                    width: screenSize - 330 + "px",
                    minHeight: "200px",
                    marginTop: "20px",
                  }}
                >
                  <Spin spinning={isLoading}>
                    <Table
                      columns={columns}
                      dataSource={data}
                      pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "20", "30", "50"],
                        onChange: (page, pageSize) => {
                          // Update the pagination state with the new page number and page size
                          setPagination((prevPagination: any) => ({
                            ...prevPagination,
                            current: page,
                            pageSize: pageSize,
                          }));
                        },
                        onShowSizeChange: (current, size) => {
                          // This ensures that the page size is updated when the size changer is used
                          setPagination((prevPagination: any) => ({
                            ...prevPagination,
                            pageSize: size,
                            current: 1, // Reset to page 1 when page size is changed
                          }));
                        },
                      }}
                      onChange={(pagination) =>
                        setPagination({
                          ...pagination,
                          total: pagination.total,
                        })
                      }
                      rowKey="paginationId"
                      bordered
                      size="middle"
                    />
                  </Spin>
                  {exceededMaterials.length > 0 && (
                    <div
                      className="mt-2"
                      style={{
                        color: "#cf1322",
                        fontSize: "13px",
                        fontWeight: 500,
                        textAlign: "right",
                      }}
                    >
                      {exceededMaterials.map((item, idx) => (
                        <div key={idx} style={{ marginBottom: "4px" }}>
                          <b>{item.label}</b>: Entered Qty ({item.enteredQty})
                          exceeds Issue Remaining Qty ({item.remainingQty})
                        </div>
                      ))}
                      {canBypassApproval
                        ? " You are authorized to proceed."
                        : " Approval is required to proceed."}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {showSubmitDrawer && (
            <SiteInventoryAllocationDrawer
              visible={showSubmitDrawer}
              // site={site}
              site={selectedSiteId}
              contractor={contractor}
              exceededMaterials={exceededMaterials}
              // lines={data
              //   .map((item: any) => {
              //     if (item.uomQty && item.uomQty !== "") {
              //       console.log("item", item);
              //       return item;
              //     }
              //     return null;
              //   })
              //   .filter((item: any) => item !== null)}
              lines={allEditedLines}
              onClose={() => setShowSubmitDrawer(false)}
              onSubmit={(data: any) => handelCreationSubmit(data)} // Ensure this is correctly passed
            />
          )}
        </Card>
      </Content>
    </>
  );
};

export default SiteIssue;
